import { render, staticRenderFns } from "./IconGia.vue?vue&type=template&id=2930fcc7"
import script from "./IconGia.vue?vue&type=script&lang=js"
export * from "./IconGia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports